<template>
  <div class="ls_spin_container">
    <div v-if="money_orders.data.length === 0" class="ls_empty_list">
      Документы отсутствуют
    </div>
    <div v-else>
      <Card v-for="doc in money_orders.data" :key="doc.id" class="card-container" style="margin-bottom: 15px">
        <Row>
          <Col span="12">
            <div @click="showDrawer(doc.id)" style="cursor: pointer">
<!--            <router-link-->
<!--              :to="{ name: 'money_order_detail', params: { id: doc.id } }"-->
<!--            >-->
              <h3>
                <Tooltip :content="applied_display(doc)" placement="right-end">
                  <Icon v-if="doc.applied" type="ios-arrow-dropdown-circle" color="#25D77E" ></Icon>
                  <Icon v-else type="ios-warning" color="#EF6E57"></Icon>
                </Tooltip>
                <!--<Icon type="md-cash" color="#646363" size="18"/>-->
                <Tooltip content="Денежный документ" placement="right-end">
                  <Icon type="logo-usd" color="#DEDEDE"/>
                </Tooltip>

                {{ doc.name }}
                <!--<Tag-->
                  <!--v-if="doc.applied"-->
                  <!--color="success"-->
                  <!--style="margin-left: 15px;"-->
                  <!--&gt;проведен</Tag-->
                <!--&gt;-->
                <!--<Tag v-else color="warning" style="margin-left: 15px;"-->
                  <!--&gt;не проведен</Tag-->
                <!--&gt;-->
              </h3>
<!--            </router-link>-->
            </div>
            <Tag v-if="doc.category_display">{{ doc.category_display }}</Tag>
            <p style="font-size: 14px; margin-top: 10px; color: rgba(14,37,74,0.5)">{{ formatDateTime(doc.order_date) }}</p>
          </Col>
          <Col span="12" style="text-align: right">
            <h3 :style="{ color: total_sum_attr(doc.type).color }">
              {{ total_sum_attr(doc.type).sign
              }}{{ formatNumber(doc.sum) }} {{ currency }}
            </h3>
          </Col>
        </Row>
      </Card>
      <Button
        class="mb-24"
        v-show="
          money_orders.current_page * money_orders.limit <
            money_orders.total_records
        "
        style="width: 100%"
        type="info"
        @click="money_orders.current_page++"
        >Показать еще</Button
      >
    </div>
    <Spin size="large" fix v-if="money_orders.loading"></Spin>
    <drawersCommonDocs :item="drawerItem"></drawersCommonDocs>
  </div>
</template>

<script>
import { base_url, server_addr } from "../../http.js";
import {formatDate, formatDateTime, formatNumber} from "../../base/base_func";
import drawersCommonDocs from "@/apps/partial/drawers_docs.vue";

export default {
  name: "recentMoneyOrders",
  props: {
    filter_by: String,
    filter_by_id: [Number, String],
    extra_param: String,
    extra_param_value: [Number, String]
  },
  components: {
    drawersCommonDocs
  },
  data() {
    return {
      money_orders: {
        data: [],
        total_records: 0,
        last_draw: 0,
        loading: true,
        current_page: 1,
        limit: 10
      },
      drawerItem: {
        show: false,
        id: null,
        type: null
      },
    };
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    }
  },
  methods: {
    applied_display(doc) {
      return doc.applied ? "Проведен": "Не проведен";
    },
    total_sum_attr: function(doc_type) {
      let sign = "";
      let color = "";

      if (doc_type === "coming") {
        sign = "+";
        color = "#25D77E";
      } else if (doc_type === "outgoing") {
        sign = "-";
        color = "#EF6E57";
      }
      return { sign, color };
    },

    fetchMoneyOrders: function() {
      const url = base_url + "/money_orders/";
      this.money_orders.loading = true;
      this.money_orders.last_draw++;

      let params = {
        format: "table",
        draw: this.money_orders.last_draw,
        offset:
          this.money_orders.limit * this.money_orders.current_page -
          this.money_orders.limit,
        limit: this.money_orders.limit,
        product: this.id
      };

      params[this.filter_by] = this.filter_by_id;
      params[this.extra_param] = this.extra_param_value;

      this.$http
        .get(url, { params: params })
        .then(result => {
          if (result.data.draw === this.money_orders.last_draw) {
            for (let doc of result.data.results) {
              this.money_orders.data.push(doc);
            }
            this.money_orders.total_records = result.data.count;
          }
        })
        .finally(() => {
          this.money_orders.loading = false;
        });
    },

    // set_initial_money_orders: function() {
    //   this.money_orders = {
    //     data: [],
    //     total_records: 0,
    //     last_draw: 0,
    //     loading: true,
    //     current_page: 1,
    //     limit: 10
    //   };
    // },

    // Форматирование
    formatNumber (number) {
      return formatNumber(number);
    },
    formatDate (date) {
      return formatDate(date);
    },
    formatDateTime  (datetime) {
      return formatDateTime(datetime);
    },
    showDrawer(doc_id) {
      this.drawerItem = {
        show: true,
        id: doc_id,
        type: 'money_order'
      };
    }
  },
  mounted() {
    this.fetchMoneyOrders();
  },

  // Скроллинг документов
  watch: {
    "money_orders.current_page": function() {
      this.fetchMoneyOrders();
    }
  }
};
</script>

<style scoped>
.ls_empty_list {
  text-align: center;
  font-size: 24px;
  color: rgba(191, 191, 191, 0.87);
  margin-top: 60px;
  margin-bottom: 60px;
}
.ls_card {
  width: 100%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/recentMoneyOrders.vue